import { idX } from "@insightfulscience/shared-utils/fn";
import type { IStorage } from "@interfaces";
import { ItemStorageFactory } from "./itemStorage";

export const token = ({ storage }: { storage: IStorage }) =>
	ItemStorageFactory<string>(storage, "token", { expires: 365 }, idX, idX);
